import { render } from "./ImageThumb.vue?vue&type=template&id=0fc2213a"
import script from "./ImageThumb.vue?vue&type=script&lang=js"
export * from "./ImageThumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__